<div class="l-container" tg>
  @if (userInitialised) {
    <section class="h-spacing-page-bottom">
      <tm-notifications></tm-notifications>
      <motors-header></motors-header>
      <router-outlet></router-outlet>
      <tg-teleport-outlet (change)="updateIsModalActive($event)" name="modal">
      </tg-teleport-outlet>
    </section>
  } @else {
    <section>
      @if (error) {
        <tg-info-box tgStyle="danger">
          <tg-icon alt="Error" name="basic-warning-framed"> </tg-icon>
          There is an error: {{ error }}
        </tg-info-box>
      }
    </section>
  }
</div>
